module.exports = __webpack_public_path__ + "img/modalPropuesta.6724e962.svg";